import { render, staticRenderFns } from "./ColorFamily.vue?vue&type=template&id=5ac9f93f&"
import script from "./ColorFamily.vue?vue&type=script&lang=js&"
export * from "./ColorFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports